import {
  useOrganizationDepartments,
  useOrganizationUsers,
} from '@/organization/useOrganizations';
import { Department } from '@/types/department';
import { Organization } from '@/types/organization';
import { User } from '@/types/user';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export function OrganizationUsersDepartmentsTable({
  organization,
}: {
  organization: Organization;
}) {
  const { data: users, isLoading: usersLoading } = useOrganizationUsers(
    organization.id,
  );
  const { data: departments, isLoading: deptsLoading } =
    useOrganizationDepartments(organization.id);

  return (
    <Box>
      <Typography variant={'h6'} gutterBottom>
        Users
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersLoading ? (
              <TableRow>
                <TableCell colSpan={3}>Loading users...</TableCell>
              </TableRow>
            ) : users && users.length > 0 ? (
              users.map((user: User) => (
                <TableRow key={user.uuid}>
                  <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <Chip
                      label={user.isAdmin ? 'Admin' : 'Member'}
                      size={'small'}
                      color={user.isAdmin ? 'primary' : 'default'}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No users found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={'h6'} gutterBottom>
        Departments
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Owner</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deptsLoading ? (
              <TableRow>
                <TableCell colSpan={3}>Loading departments...</TableCell>
              </TableRow>
            ) : departments && departments.length > 0 ? (
              departments.map((dept: Department) => (
                <TableRow key={dept.id}>
                  <TableCell>{dept.name}</TableCell>
                  <TableCell>{dept.description}</TableCell>
                  <TableCell>{dept.owner ?? '—'}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No departments found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
